const langs: General.Language[] = [
  'zh-CN',
  'en-US',
  'id',
  'pt',
  'th',
  'vi',
  'zh-TW',
  'tl',
  'es',
  'ms',
  'pl',
  'my',
];

interface region2LangsOption {
  /** 默认语言 */
  defaultValue: General.Language;
  /** 优先展示语言项 */
  priority: General.Language[];
  /** 折叠语言项 */
  more: General.Language[];
}

/**
 * 站点对应的翻译语言配置
 * https://leyan.yuque.com/czpqnb/pd/vd10aa21tpgmcmo9#2hrP
 */
export const defaultRegion2Langs: Record<
  Exclude<General.UpperCaseRegion, 'ES' | 'KR'>,
  region2LangsOption
> = {
  ID: {
    defaultValue: 'id',
    priority: ['id', 'en-US'],
    more: ['tl', 'ms', 'th', 'my', 'vi', 'pt', 'es', 'pl', 'fr', 'zh-TW', 'zh-CN'],
  },
  MY: {
    defaultValue: 'en-US',
    priority: ['ms', 'en-US'],
    more: ['id', 'tl', 'th', 'my', 'vi', 'pt', 'es', 'pl', 'fr', 'zh-TW', 'zh-CN'],
  },
  PH: {
    defaultValue: 'en-US',
    priority: ['tl', 'en-US'],
    more: ['id', 'ms', 'th', 'my', 'vi', 'pt', 'es', 'pl', 'fr', 'zh-TW', 'zh-CN'],
  },
  TH: {
    defaultValue: 'th',
    priority: ['th', 'my', 'vi', 'en-US'],
    more: ['id', 'tl', 'ms', 'pt', 'es', 'pl', 'fr', 'zh-TW', 'zh-CN'],
  },
  VN: {
    defaultValue: 'vi',
    priority: ['vi', 'en-US'],
    more: ['id', 'tl', 'ms', 'th', 'my', 'pt', 'es', 'pl', 'fr', 'zh-TW', 'zh-CN'],
  },
  SG: {
    defaultValue: 'en-US',
    priority: ['en-US'],
    more: ['id', 'tl', 'ms', 'th', 'my', 'vi', 'pt', 'es', 'pl', 'fr', 'zh-TW', 'zh-CN'],
  },
  BR: {
    defaultValue: 'pt',
    priority: ['pt', 'en-US'],
    more: ['id', 'tl', 'ms', 'th', 'my', 'vi', 'es', 'pl', 'fr', 'zh-TW', 'zh-CN'],
  },
  MX: {
    defaultValue: 'es',
    priority: ['es', 'en-US'],
    more: ['id', 'tl', 'ms', 'th', 'my', 'vi', 'pt', 'pl', 'fr', 'zh-TW', 'zh-CN'],
  },
  CO: {
    defaultValue: 'es',
    priority: ['es', 'en-US'],
    more: ['id', 'tl', 'ms', 'th', 'my', 'vi', 'pt', 'pl', 'fr', 'zh-TW', 'zh-CN'],
  },
  CL: {
    defaultValue: 'es',
    priority: ['es', 'en-US'],
    more: ['id', 'tl', 'ms', 'th', 'my', 'vi', 'pt', 'pl', 'fr', 'zh-TW', 'zh-CN'],
  },
  AR: {
    defaultValue: 'es',
    priority: ['es', 'en-US'],
    more: ['id', 'tl', 'ms', 'th', 'my', 'vi', 'pt', 'pl', 'fr', 'zh-TW', 'zh-CN'],
  },
  PL: {
    defaultValue: 'pl',
    priority: ['pl'],
    more: ['id', 'en-US', 'tl', 'ms', 'th', 'my', 'vi', 'pt', 'es', 'fr', 'zh-TW', 'zh-CN'],
  },
  US: {
    defaultValue: 'en-US',
    priority: ['en-US'],
    more: ['id', 'tl', 'ms', 'th', 'my', 'vi', 'pt', 'es', 'pl', 'fr', 'zh-TW', 'zh-CN'],
  },
  GB: {
    defaultValue: 'en-US',
    priority: ['en-US'],
    more: ['id', 'tl', 'ms', 'th', 'my', 'vi', 'pt', 'es', 'pl', 'fr', 'zh-TW', 'zh-CN'],
  },
  TW: {
    defaultValue: 'zh-TW',
    priority: ['zh-TW'],
    more: ['id', 'en-US', 'tl', 'ms', 'th', 'my', 'vi', 'pt', 'es', 'pl', 'fr', 'zh-CN'],
  },
  DE: {
    defaultValue: 'de',
    priority: ['de', 'en-US'],
    more: ['id', 'tl', 'ms', 'th', 'my', 'vi', 'pt', 'es', 'pl', 'fr', 'zh-TW', 'zh-CN'],
  },
  IT: {
    defaultValue: 'it',
    priority: ['it', 'en-US'],
    more: ['id', 'tl', 'ms', 'th', 'my', 'vi', 'pt', 'es', 'pl', 'fr', 'zh-TW', 'zh-CN'],
  },
  JP: {
    defaultValue: 'ja',
    priority: ['ja', 'en-US'],
    more: ['id', 'tl', 'ms', 'th', 'my', 'vi', 'pt', 'es', 'pl', 'fr', 'zh-TW', 'zh-CN'],
  },
  IE: {
    defaultValue: 'en-US',
    priority: ['en-US'],
    more: ['id', 'tl', 'ms', 'th', 'my', 'vi', 'pt', 'es', 'pl', 'fr', 'zh-TW', 'zh-CN'],
  },
  FR: {
    defaultValue: 'fr',
    priority: ['fr', 'en-US'],
    more: ['id', 'tl', 'ms', 'th', 'my', 'vi', 'pt', 'es', 'pl', 'zh-TW', 'zh-CN'],
  },
  NL: {
    defaultValue: 'nl',
    priority: ['nl'],
    more: ['fr', 'en-US', 'id', 'tl', 'ms', 'th', 'my', 'vi', 'pt', 'es', 'pl', 'zh-TW', 'zh-CN'],
  },
  BE: {
    defaultValue: 'nl',
    priority: ['nl', 'fr', 'de'],
    more: ['en-US', 'id', 'tl', 'ms', 'th', 'my', 'vi', 'pt', 'es', 'pl', 'zh-TW', 'zh-CN'],
  },
  CZ: {
    defaultValue: 'cs',
    priority: ['cs'],
    more: ['fr', 'en-US', 'id', 'tl', 'ms', 'th', 'my', 'vi', 'pt', 'es', 'pl', 'zh-TW', 'zh-CN'],
  },
  AT: {
    defaultValue: 'de',
    priority: ['de'],
    more: ['fr', 'en-US', 'id', 'tl', 'ms', 'th', 'my', 'vi', 'pt', 'es', 'pl', 'zh-TW', 'zh-CN'],
  },
  GR: {
    defaultValue: 'el',
    priority: ['el'],
    more: ['fr', 'en-US', 'id', 'tl', 'ms', 'th', 'my', 'vi', 'pt', 'es', 'pl', 'zh-TW', 'zh-CN'],
  },
  PT: {
    defaultValue: 'pt',
    priority: ['pt'],
    more: ['fr', 'en-US', 'id', 'tl', 'ms', 'th', 'my', 'vi', 'pt', 'es', 'pl', 'zh-TW', 'zh-CN'],
  },
  HU: {
    defaultValue: 'hu',
    priority: ['hu'],
    more: ['fr', 'en-US', 'id', 'tl', 'ms', 'th', 'my', 'vi', 'pt', 'es', 'pl', 'zh-TW', 'zh-CN'],
  },
};

export default langs;
